module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-283.642d7f1.woff2";